// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstaIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/kn-logo-mini.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "KINITECH SAS",
    location: "Cali, Colombia",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/kinitech.sas/",
    },
    {
      icon: <LinkedInIcon />,
      link: "https://co.linkedin.com/company/kinitech-sas",
    },
    {
      icon: <InstaIcon />,
      link: "https://www.instagram.com/kinitechsas/",
    },
  ],
  menus: [
    {
      name: "Contacto Comercial",
      items: [{ name: "3218022066" }, { name: "gcomercial@kinitech.com.co" }],
    },
    {
      name: "Contacto proveedores:",
      items: [{ name: "3183759561" }, { name: "coordinacion@kinitech.com.co" }],
    },
    {
      name: "Soporte técnico:",
      items: [
        { name: "WhatsApp: 3173712554" },
        {
          name: "Correo: soporte@kinitech.com.co",
        },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      © {date} KINITECH SAS · Cali, Colombia. Todos los derechos reservados.
    </MKTypography>
  ),
};
